export default __webpack_public_path__ + "static/media/logo.baba14c9.svg";